// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__S91EB","tyre":"style_tyre__DAKUY"};